// src/constants/fishIQSeed.ts
// Seed-aware FishIQ catalog export.
// Keeps your existing fishiqSeed.json as the base, then appends Roddo's curated
// aquatic expansion (shellfish, crustaceans, mollusks, cephalopods, extra finfish).

import type { FishIQSpeciesSeed } from '../types';
import raw from './fishiqSeed.json';
import { AQUATIC_SPECIES_SEED } from '../data/aquaticSpecies';
import { attachFishIQPublicSourceRefs } from './fishIQPublicSources';
import { SOCAL_FISHIQ_SPECIES_SEED } from './fishIQSoCalSpecies';
import { FISHIQ_LAUNCH_SPECIES_SEED } from './fishIQLaunchSpecies';
import { FISHIQ_REGIONAL_SPECIES_SEED } from '../data/fishIQRegionalSpeciesRegistry';
import { attachFishIQSpeciesKnowledge } from './fishIQSpeciesKnowledge';
import { buildFishIQCanonicalMetadata, mergeCanonicalFishIQSpeciesSeeds } from '../data/fishIQCanonicalSpecies';
import { applyFishIQRegionalEnrichment } from '../data/fishIQRegionalEnrichment';

export const BASE_FISHIQ_SPECIES_SEED: FishIQSpeciesSeed[] = raw as FishIQSpeciesSeed[];

const ENRICHED_FISHIQ_SPECIES_SEED: FishIQSpeciesSeed[] = attachFishIQPublicSourceRefs(
  attachFishIQSpeciesKnowledge(
    mergeCanonicalFishIQSpeciesSeeds(
      BASE_FISHIQ_SPECIES_SEED,
      AQUATIC_SPECIES_SEED as FishIQSpeciesSeed[],
      SOCAL_FISHIQ_SPECIES_SEED as FishIQSpeciesSeed[],
      FISHIQ_LAUNCH_SPECIES_SEED as FishIQSpeciesSeed[],
      FISHIQ_REGIONAL_SPECIES_SEED as FishIQSpeciesSeed[],
    ),
  ),
);

// Refresh canonical quality metadata after source refs and knowledge are attached.
// Otherwise the health panel can report stale "missing source" counts.
const REGION_ENRICHED_FISHIQ_SPECIES_SEED = applyFishIQRegionalEnrichment(ENRICHED_FISHIQ_SPECIES_SEED);

export const FISHIQ_SPECIES_SEED: FishIQSpeciesSeed[] = REGION_ENRICHED_FISHIQ_SPECIES_SEED.map((species: any) => ({
  ...species,
  canonicalSpecies: buildFishIQCanonicalMetadata(
    species,
    species?.canonicalSpecies?.legacyIds || [species.id].filter(Boolean),
  ),
}));
